import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import GameFlow from './pages/GameFlow';
import SpinWheelFlow from './pages/SpinWheelFlow';
import PeelRevealFlow from './pages/PeelRevealFlow';
import SlotMachineFlow from './pages/SlotMachineFlow';
import FlipRevealFlow from './pages/FlipRevealFlow';
import BalloonPopFlow from './pages/BalloonPopFlow';
import LiveQuizArena from './pages/LiveQuizArena';
import LiveWordScramble from './pages/LiveWordScramble';
import TreasureBoxFlow from './pages/TreasureBoxFlow';
import LiveEmojiQuest from './pages/LiveEmojiQuest';
import PinataFlow from './pages/PinataFlow';
import AnimalMatchFlow from './pages/AnimalMatchFlow';
import RainbowPopFlow from './pages/RainbowPopFlow';
import MissionChandrayaan from './pages/MissionChandrayaan';
import RocketBuilderFlow from './pages/RocketBuilderFlow';
import CosmicGravityFlow from './pages/CosmicGravityFlow';
import ColorLabFlow from './pages/ColorLabFlow';
import SolarSystemFlow from './pages/SolarSystemFlow';
import DinoFossilFlow from './pages/DinoFossilFlow';
import PlayRedirect from './pages/PlayRedirect';
import LiveHouseBarometerStage from './pages/LiveHouseBarometerStage';
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './pages/AdminLogin';
import ThemeToggle from './components/ThemeToggle';
import AudioWidget from './components/AudioWidget';
import GlassPotTokenDraw from './components/GlassPotTokenDraw';
import '@questlabs/react-sdk/dist/style.css';
import './index.css';

// Secure Route Wrapper for Admin Access
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('admin_auth') === 'true';
  return isAuthenticated ? children : <Navigate to="/admin-login" replace />;
};

function App() {
  return (
    <Router>
      <ThemeToggle />
      <AudioWidget />
      <Routes>
        {/* Campaign Selection */}
        <Route path="/" element={<Home />} />
        
        {/* Game Flows */}
        <Route path="/scratch" element={<GameFlow />} />
        <Route path="/spin" element={<SpinWheelFlow />} />
        <Route path="/peel" element={<PeelRevealFlow />} />
        <Route path="/slot" element={<SlotMachineFlow />} />
        <Route path="/flip" element={<FlipRevealFlow />} />
        <Route path="/balloon" element={<BalloonPopFlow />} />
        <Route path="/treasure" element={<TreasureBoxFlow />} />
        <Route path="/quiz" element={<LiveQuizArena />} />
        <Route path="/live-quiz" element={<LiveQuizArena />} />
        <Route path="/scramble" element={<LiveWordScramble />} />
        <Route path="/live-scramble" element={<LiveWordScramble />} />
        <Route path="/emoji" element={<LiveEmojiQuest />} />
        <Route path="/live-emoji" element={<LiveEmojiQuest />} />
        <Route path="/pinata" element={<PinataFlow />} />
        <Route path="/animal-match" element={<AnimalMatchFlow />} />
        <Route path="/safari" element={<AnimalMatchFlow />} />
        <Route path="/rainbow-pop" element={<RainbowPopFlow />} />
        <Route path="/bubble" element={<RainbowPopFlow />} />
        <Route path="/chandrayaan" element={<MissionChandrayaan />} />
        <Route path="/space-landing" element={<MissionChandrayaan />} />
        <Route path="/rocket-builder" element={<RocketBuilderFlow />} />
        <Route path="/rocket" element={<RocketBuilderFlow />} />
        <Route path="/gravity-lab" element={<CosmicGravityFlow />} />
        <Route path="/gravity" element={<CosmicGravityFlow />} />
        <Route path="/color-lab" element={<ColorLabFlow />} />
        <Route path="/alchemist" element={<ColorLabFlow />} />
        <Route path="/solar-system" element={<SolarSystemFlow />} />
        <Route path="/planet-explorer" element={<SolarSystemFlow />} />
        <Route path="/dino-dig" element={<DinoFossilFlow />} />
        <Route path="/fossil-hunter" element={<DinoFossilFlow />} />
        <Route path="/play" element={<PlayRedirect />} />
        
        {/* Physical Sports Day & House Championship Barometer Stage */}
        <Route path="/house-barometer" element={<LiveHouseBarometerStage />} />
        <Route path="/sports-barometer" element={<LiveHouseBarometerStage />} />
        <Route path="/sports-arena" element={<LiveHouseBarometerStage />} />
        
        {/* Transparent Glass Pot Token Draw (Auditorium & Stage Mode) */}
        <Route path="/token-draw" element={<div className="min-h-screen bg-slate-950 p-4 sm:p-8 flex items-center justify-center"><div className="w-full max-w-6xl"><GlassPotTokenDraw isStageMode={true} /></div></div>} />
        <Route path="/raffle-pot" element={<div className="min-h-screen bg-slate-950 p-4 sm:p-8 flex items-center justify-center"><div className="w-full max-w-6xl"><GlassPotTokenDraw isStageMode={true} /></div></div>} />
        
        {/* Admin Section */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />
        
        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;